import { RpColumn, RpColumnRenderType } from '../../../../models/RpColumn';
import { EsField } from '../../../../services/dtos/riskProducts/rpColumn.dto';

export const REQUIRED_COLUMNS: EsField[] = [
  'display_name',
  'display_ticker',
  'selection',
  'displayName',
  'displayTicker',
];

export const MANAGE_SCORE_COLUMNS: RpColumn[] = [
  {
    group: 'CoreScore',
    data_field: 'Sector Risk',
    es_field: 'coreScores.sector',
    renderType: RpColumnRenderType.SCORE,
    canAccess: true,
  },
  {
    group: 'CoreScore',
    data_field: 'Event Risk',
    es_field: 'coreScores.event',
    renderType: RpColumnRenderType.SCORE,
    canAccess: true,
  },
  {
    group: 'CoreScore',
    data_field: 'Cash Flow',
    es_field: 'coreScores.cash_flow',
    renderType: RpColumnRenderType.SCORE,
    canAccess: true,
  },
  {
    group: 'CoreScore',
    data_field: 'Leverage',
    es_field: 'coreScores.leverage',
    renderType: RpColumnRenderType.SCORE,
    canAccess: true,
  },
  {
    group: 'CoreScore',
    data_field: 'Liquidity',
    es_field: 'coreScores.liquidity',
    renderType: RpColumnRenderType.SCORE,
    canAccess: true,
  },
  {
    group: 'CoreScore',
    data_field: 'Profitability',
    es_field: 'coreScores.profitability',
    renderType: RpColumnRenderType.SCORE,
    canAccess: true,
  },
  {
    group: 'CoreScore',
    data_field: 'Capital',
    es_field: 'coreScores.capital',
    renderType: RpColumnRenderType.SCORE,
    canAccess: true,
  },
  {
    group: 'CoreScore',
    data_field: 'Asset Quality',
    es_field: 'coreScores.asset_quality',
    renderType: RpColumnRenderType.SCORE,
    canAccess: true,
  },
];
